export default "__VITE_ASSET__Ceevcf5v__"